(() => {
  if (window.__miipasCookieBar) return;
  window.__miipasCookieBar = true;

  document.querySelectorAll("[data-cookie-bar]").forEach((root) => {
    const key = "miipas-cookie-banner";
    if (new URLSearchParams(window.location.search).has("reset-cookie")) {
      localStorage.removeItem(key);
    }
    const delay = Number(root.dataset.delay || 4) * 1000;
    const syncOffset = () => {
      const visible = !root.hidden && root.classList.contains("is-in");
      const height = visible ? root.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty("--cookie-bar-h", `${Math.round(height)}px`);
    };
    const hide = () => {
      root.hidden = true;
      syncOffset();
    };
    const reveal = () => {
      root.classList.add("is-ready");
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          root.classList.add("is-in");
          syncOffset();
        });
      });
    };
    const choose = (accepted) => {
      localStorage.setItem(key, accepted ? "yes" : "no");
      hide();
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!accepted || !privacy || typeof privacy.setTrackingConsent !== "function") return;
      const current = privacy.currentVisitorConsent ? privacy.currentVisitorConsent() : {};
      if (current.analytics === "no" || current.marketing === "no") {
        privacy.setTrackingConsent(
          { analytics: true, marketing: true, preferences: true, sale_of_data: true },
          () => {}
        );
      }
    };
    if (localStorage.getItem(key)) {
      hide();
    } else {
      window.setTimeout(reveal, delay);
    }
    root.querySelector("[data-cookie-accept]")?.addEventListener("click", () => choose(true));
    root.querySelector("[data-cookie-decline]")?.addEventListener("click", () => choose(false));
    window.addEventListener("resize", syncOffset);
    if (typeof ResizeObserver !== "undefined") new ResizeObserver(syncOffset).observe(root);
  });
})();
